export default __webpack_public_path__ + "media/images/biscuits-6e4cb648990f0333169ba3b4b32db6dc.png";